<template>
  <reestr-layout>
    <div>
      <div class="columns">
        <div class="column">
          <GisogdDocProperties
            :project-schema="projectSchema"
            :doc="docInfo"
            class="isogddoc-panel container has-background-white"
            :showInfosetGeometry="true"
          >
            <template slot-scope="{ doc }" v-if="doc.hasGeometry">
              <router-link
                :to="{
                  name: 'map',
                  params: { projectSchema: projectSchema },
                  query: {
                    section: gisogdSection,
                    infoSetKey: doc.infoSetKey,
                    docKey: doc.key,
                    onlyDocument: true,
                  },
                }"
                class="button is-link"
                tag="button"
              >
                <span class="icon is-small">
                  <img src="../assets/svg/map_icon_white.svg" />
                </span>
                <span title="Посмотреть действующий документ на карте"
                  >Посмотреть на карте</span
                >
              </router-link>
              <br />
              <br />
            </template>
            <template v-slot:map="{ doc }">
              <template v-if="doc.infosetGeoJson">
                <LeafletMapLoader
                  :mapConfig="mapConfig"
                  v-if="mapConfig"
                  mapClass="map"
                >
                  <template slot-scope="{ leaflet, map }">
                    <LeafletBackgroundLayer
                      v-if="activeBackgroundLayer"
                      :leaflet="leaflet"
                      :map="map"
                      :background-layer="activeBackgroundLayer"
                    ></LeafletBackgroundLayer>
                    <LeafletMapSelection
                      :map="map"
                      :leaflet="leaflet"
                      :geoJsonGeometry="doc.infosetGeoJson"
                    ></LeafletMapSelection>
                    <LeafletMapFitBound
                      :map="map"
                      :leaflet="leaflet"
                      :geoJsonGeometry="doc.infosetGeoJson"
                    ></LeafletMapFitBound>
                  </template>
                </LeafletMapLoader>
              </template>
            </template>
          </GisogdDocProperties>
        </div>
      </div>
    </div>
  </reestr-layout>
</template>

<script>
import store from "../store";
import { mapState } from "vuex";
import ReestrLayout from "./ReestrLayout";
import GisogdDocProperties from "@/components/map/GisogdDocProperties";
import LeafletMapLoader from "@/components/map/leaflet/LeafletMapLoader";
import LeafletBackgroundLayer from "../components/map/leaflet/LeafletBackgroundLayer";
import LeafletMapSelection from "@/components/map/leaflet/LeafletMapSelection";
import LeafletMapFitBound from "@/components/map/leaflet/LeafletMapFitBound";

export default {
  props: {
    projectSchema: {
      type: String,
      required: true,
    },
    gisogdSection: {
      type: String,
      required: true,
    },
    docId: { required: true },
  },
  components: {
    ReestrLayout,
    GisogdDocProperties,
    LeafletMapLoader,
    LeafletBackgroundLayer,
    LeafletMapSelection,
    LeafletMapFitBound,
  },
  computed: {
    docInfo() {
      return { gisogdSection: this.gisogdSection, key: this.docId };
    },
    ...mapState(["mapConfig", "activeBackgroundLayer"]),
  },

  async beforeRouteEnter(to, from, next) {
    await beforeRouter(to, from, next);
  },
};
const beforeRouter = async (to, from, next) => {
  await store.dispatch("fetchMapConfigAsync", {
    gisogdSection: to.query.section,
    infoSetKey: to.query.infoSetKey,
    docKey: to.query.docKey,
    onlyDocument: to.query.onlyDocument,
  });

  next();
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../assets/sass/main.scss";
.map {
  height: 100%;
  width: 100%;
}

.isogddoc-panel {
  margin-top: 3.6rem !important;
  flex-direction: column;
  border-radius: 6px;
  padding: 26px 53px;
}

.isogddoc-panel h5 {
  margin-top: 17px;
  line-height: 145%;
}

.search-panel {
  height: 190px;
  background-color: $blue;
}

.search-panel-footer {
  height: 47px;
  background-color: $cyan;
}

.property-files {
  color: $grey;
}
</style>
